import script from "./TempF.vue?vue&type=script&lang=ts&setup=true"
export * from "./TempF.vue?vue&type=script&lang=ts&setup=true"

import "./TempF.vue?vue&type=style&index=0&id=40530432&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40530432"]])

export default __exports__